import { LinkedInFilledIcon, InstagramFilledIcon, YoutubeFilledIcon, HouzzFilledIcon, PinterestFilledIcon, XIcon, FacebookFilledIcon } from '@kohler-dsm-library/kohler-icons';

const sharePopoverIconMap = {
  facebook: FacebookFilledIcon,
  twitter: XIcon,
  x: XIcon,
  pinterest: PinterestFilledIcon,
  houzz: HouzzFilledIcon,
  youtube: YoutubeFilledIcon,
  instagram: InstagramFilledIcon,
  linkedin: LinkedInFilledIcon
};

export { sharePopoverIconMap };
